import React from 'react'
import { Ordering } from 'storfox-filter'

import { TPL_BILLING_COLUMNS as tableColumns } from './TplBillingList'

import { FILTER_NAME as name } from '../../constants'

export const tplBillingOrderingOptions = {
  name,
  tableColumns
}

function TplBillingOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default TplBillingOrderingForm
